import { MantineProvider, type MantineThemeOverride, mergeThemeOverrides } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type PropsWithChildren, useState } from "react";
import LoadingOverlayProvider from "../../providers/LoadingOverlayProvider";
import { dutyonTheme } from "../../theme";

export interface UikitProviderProps extends PropsWithChildren {
  theme?: MantineThemeOverride;
}

export function UikitProvider({ children, theme }: UikitProviderProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
          },
        },
      }),
  );

  return (
    <MantineProvider theme={theme ? mergeThemeOverrides(dutyonTheme, theme) : dutyonTheme}>
      <Notifications />
      <LoadingOverlayProvider>
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>{children}</ModalsProvider>
        </QueryClientProvider>
      </LoadingOverlayProvider>
    </MantineProvider>
  );
}
